import { ProductCardStructure } from 'common/components';
import { FENCES_CDN_PATH } from '../../fences-constants';

const PROFNASTIL_GATES_LIST: ProductCardStructure[] = [
  {
    name: 'Ворота откатные',
    imgSrc: `${FENCES_CDN_PATH}/gates/zabory-iz-profnastila/1.png/1.png`,
    alt: 'Ворота откатные',
  },
  {
    name: 'Ворота распашные',
    imgSrc: `${FENCES_CDN_PATH}/gates/zabory-iz-profnastila/2.png/2.png`,
    alt: 'Ворота распашные',
  },
  {
    name: 'Калитка',
    imgSrc: `${FENCES_CDN_PATH}/gates/zabory-iz-profnastila/3.png/3.png`,
    alt: 'Калитка',
  },
  {
    name: 'Декоративный полустолб',
    imgSrc: `${FENCES_CDN_PATH}/gates/zabory-iz-profnastila/4.png/4.png`,
    alt: 'Декоративный полустолб',
  },
];

const SHTAKETNIK_GATES_LIST: ProductCardStructure[] = [
  {
    name: 'Ворота откатные',
    imgSrc: `${FENCES_CDN_PATH}/gates/metallicheskiy-shtaketnik/1.png/1.png`,
    alt: 'Ворота откатные',
  },
  {
    name: 'Ворота распашные',
    imgSrc: `${FENCES_CDN_PATH}/gates/metallicheskiy-shtaketnik/2.png/2.png`,
    alt: 'Ворота распашные',
  },
  {
    name: 'Калитка',
    imgSrc: `${FENCES_CDN_PATH}/gates/metallicheskiy-shtaketnik/3.png/3.png`,
    alt: 'Калитка',
  },
];

const MODULNYE_OGRAZHDENIYA_GATES_LIST: ProductCardStructure[] = [
  {
    name: 'Ворота откатные',
    imgSrc: `${FENCES_CDN_PATH}/gates/modulnye-ograzhdeniya/1.png/1.png`,
    alt: 'Ворота откатные',
  },
  {
    name: 'Ворота распашные',
    imgSrc: `${FENCES_CDN_PATH}/gates/modulnye-ograzhdeniya/2.png/2.png`,
    alt: 'Ворота распашные',
  },
  {
    name: 'Калитка',
    imgSrc: `${FENCES_CDN_PATH}/gates/modulnye-ograzhdeniya/3.png/3.png`,
    alt: 'Калитка',
  },
  {
    name: 'Декоративный полустолб',
    imgSrc: `${FENCES_CDN_PATH}/gates/modulnye-ograzhdeniya/4.png/4.png`,
    alt: 'Декоративный полустолб',
  },
];

const PANELNYE_OGRAZHDENIYA_GATES_LIST: ProductCardStructure[] = [
  {
    name: 'Ворота откатные',
    imgSrc: `${FENCES_CDN_PATH}/gates/panelnye-ograzhdeniya/1.png/1.png`,
    alt: 'Ворота откатные',
  },
  {
    name: 'Ворота распашные',
    imgSrc: `${FENCES_CDN_PATH}/gates/panelnye-ograzhdeniya/2.png/2.png`,
    alt: 'Ворота распашные',
  },
  {
    name: 'Калитка',
    imgSrc: `${FENCES_CDN_PATH}/gates/panelnye-ograzhdeniya/3.png/3.png`,
    alt: 'Калитка',
  },
];

const ZHALYUZI_GATES_LIST: ProductCardStructure[] = [
  {
    name: 'Ворота откатные',
    imgSrc: `${FENCES_CDN_PATH}/gates/zabory-zhalyuzi/1.png/1.png`,
    alt: 'Ворота откатные',
  },
  {
    name: 'Ворота распашные',
    imgSrc: `${FENCES_CDN_PATH}/gates/zabory-zhalyuzi/2.png/2.png`,
    alt: 'Ворота распашные',
  },
  {
    name: 'Калитка',
    imgSrc: `${FENCES_CDN_PATH}/gates/zabory-zhalyuzi/3.png/3.png`,
    alt: 'Калитка',
  },
  {
    name: 'Декоративный полустолб',
    imgSrc: `${FENCES_CDN_PATH}/gates/zabory-zhalyuzi/4.png/4.png`,
    alt: 'Декоративный полустолб',
  },
];

export const FENCES_GATES_LIST_MAP: Record<string, ProductCardStructure[]> = {
  'zabory-iz-profnastila': PROFNASTIL_GATES_LIST,
  'metallicheskiy-shtaketnik': SHTAKETNIK_GATES_LIST,
  'modulnye-ograzhdeniya': MODULNYE_OGRAZHDENIYA_GATES_LIST,
  'panelnye-ograzhdeniya': PANELNYE_OGRAZHDENIYA_GATES_LIST,
  'zabory-zhalyuzi': ZHALYUZI_GATES_LIST,
};
